import { GoldButton } from "./GoldButton";
import { Reveal, MaskedLine } from "./Reveal";

export const VideoSection = () => (
  <section className="relative px-5 py-28 sm:px-8 lg:py-36" data-testid="video-section">
    <div className="mx-auto max-w-5xl">
      <Reveal>
        <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
          <span className="h-px w-10 bg-gold/60" /> Il video
        </p>
      </Reveal>
      <h2 className="mt-6 font-display text-3xl font-bold uppercase leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
        <MaskedLine delay={0.1}>Prima di entrare,</MaskedLine>
        <MaskedLine delay={0.22}>guarda questo video.</MaskedLine>
      </h2>
      <Reveal delay={0.35}>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-ivory/60 sm:text-lg">
          3 minuti per capire perché abbiamo creato il Deserto e cosa potrebbe iniziare da questi 40 giorni.
        </p>
      </Reveal>

      <Reveal delay={0.45} className="mt-12">
        <div
          className="group relative mx-auto w-full max-w-4xl overflow-hidden border border-ivory/15"
          data-testid="vsl-video-frame"
        >
          <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
            <iframe
              src="https://www.youtube.com/embed/Gb_D4okMtYo?autoplay=1&mute=1&rel=0&modestbranding=1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              title="Sfida del Deserto — Video di presentazione"
              data-testid="vsl-video-iframe"
            />
          </div>
          <div className="pointer-events-none absolute bottom-0 left-0 flex w-full items-center gap-4 bg-gradient-to-t from-night/80 to-transparent px-5 pb-4 pt-10">
            <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-ivory/70">La Sfida del Deserto</span>
            <span className="h-px w-8 bg-ivory/30" />
            <span className="text-[10px] uppercase tracking-[0.25em] text-gold">3 min</span>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.55} className="mt-12">
        <GoldButton testId="video-cta-button" />
      </Reveal>
    </div>
  </section>
);
